import $ from "jquery";
import ClickEvent = JQuery.ClickEvent;

export const manageEmbedVideoModal = () => {
  const selector = ".embed-video";
  const ctaSelector = ".embed-video-cta";
  const modalSelector = ".embed-video-modal";

  const $embedVideoCta = $(ctaSelector);
  const $closeModalBtn = $(modalSelector + " .close");
  const $iFrameWrapper = $(modalSelector + " .iframe-wrapper");

  const closeModal = (e: ClickEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const $modal = $(e.target).closest(".embed-video-modal");
    const $cuurrentIFrameWrapper = $modal.find(".iframe-wrapper");
    $modal.hide();
    $cuurrentIFrameWrapper.html("");
  };

  $iFrameWrapper.on("click", closeModal);
  $closeModalBtn.on("click", closeModal);

  $(document).on("keyup", function (e) {
    if (e.key === "Escape") {
      // escape key maps to keycode `27`
      $closeModalBtn.trigger("click");
    }
  });

  $embedVideoCta.on("click", (e: ClickEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const $videoEmbeddedModal = $(e.target)
      .closest(selector)
      .find(modalSelector);
    const videoUrl = $(e.target).closest(ctaSelector).attr("href");
    const videoID = videoUrl?.split("/").pop()?.replace("watch?v=", "");
    if (videoID) {
      const $cuurrentIFrameWrapper =
        $videoEmbeddedModal.find(".iframe-wrapper");
      let iFrame = document.createElement("iframe");
      iFrame.width = "100%";
      iFrame.height = "100%";
      iFrame.src = "https://www.youtube.com/embed/" + videoID;
      iFrame.title = "YouTube video player";
      iFrame.allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
      iFrame.referrerPolicy = "strict-origin-when-cross-origin";
      iFrame.allowFullscreen = true;
      $cuurrentIFrameWrapper.append(iFrame);
      $videoEmbeddedModal.show();
    }
  });
};
